<template>
    <div class="financeCalculator__form__input financeCalculator__form__input--range">
        <button class="financeCalculator__form__rangeTrigger financeCalculator__form__rangeTrigger--decrease" @click="onDecrement">
            <span class="sr-only">Decrease</span>
            -
        </button>

        <input type="number"
               v-model="value"
               :autocomplete="autocomplete"
               :readonly="readonly"
               :disabled="disabled"
               :maxlength="maxlength"
               :min="min"
               :max="max"
               :step="step"
               :id="id"
               @blur.prevent="onBlur"
               @keydown.up.prevent="onIncrement"
               @keydown.down.prevent="onDecrement"
               @keydown.space.prevent
               ref="input"
        />

        <div class="financeCalculator__form__placeholder" v-show="!isEditing" @click="onPlaceholder">
            {{ formatter(value) }}
        </div>

        <button class="financeCalculator__form__rangeTrigger financeCalculator__form__rangeTrigger--increase" @click="onIncrement">
            <span class="sr-only">Increase</span>
            +
        </button>
    </div>
</template>

<script>
export default {
    props: {
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: Infinity
        },
        step: {
            type: Number,
            default: 500
        },
        defaultValue: {
            type: Number,
            default: 8990
        },
        name: {
            type: String,
        },
        autocomplete: {
            type: String,
        },
        readonly: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: Number,
        },
        id: {
            type: String,
        },
        formatter: {
            type: Function,
            default: (val) => val
        }
    },
    data() {
        return {
            value: this.defaultValue,
            isEditing: false
        }
    },
    methods: {
        onDecrement() {
            this.value = this.value - this.step
            this.validate()
        },
        onIncrement() {
            this.value = this.value + this.step
            this.validate()
        },
        onBlur() {
            this.validate()
            this.isEditing = false
        },
        validate() {
            if (this.value > this.max) {
                this.value = this.max;
            }

            if (this.value < this.min) {
                this.value = this.min;
            }
        },
        onPlaceholder() {
            this.isEditing = !this.isEditing

            if (this.isEditing) {
                this.$refs.input.focus()
            }
        }
    },
    watch: {
        value: debouncer(function(val) {
            this.$emit('input', Number(val))
        },500)
    }
}
</script>